export class ProjectItem {
  name?: string;
  coverImageUrl?: string;
  code?: string;
  latitude?: number;
  longitude?: number;
  description?: string;
  site?: string;
}
